const acl = {
  super: ['SUPER'],
  coowner: ['STANDARD'],
  superAndManager: ['SUPER', 'MANAGER'],
  boardAndCoowner: ['BOARDMEMBER', 'STANDARD'],
  superManagerAndBoard: ['SUPER', 'MANAGER', 'BOARDMEMBER'],
  all: ['SUPER', 'MANAGER', 'STANDARD', 'BOARDMEMBER'],
};

export default acl;



// WEBPACK FOOTER //
// ./src/utils/accessLevels.js